import { render, staticRenderFns } from "./gc-popup-image-preview.vue?vue&type=template&id=f4a51a52"
import script from "./gc-popup-image-preview.vue?vue&type=script&lang=js"
export * from "./gc-popup-image-preview.vue?vue&type=script&lang=js"
import style0 from "./gc-popup-image-preview.vue?vue&type=style&index=0&id=f4a51a52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports